import { Redirect, Route } from 'react-router-dom';
import { checkUserSession } from '../SERVICES/user-service';

export const CheckPrivateRoute = ({ component: Component, ...rest }: any) => (
  <Route
    {...rest}
    render={(props: any) =>
      checkUserSession() ? (
        <Redirect
          to={{
            pathname: '/welcome-learning',
            state: { from: props.location },
          }}
        />
      ) : (
        <Component {...props} />
      )
    }
  />
);
